// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnimatedSticker__sticker-dcfaf5 {
  display: inline-block;
}

.AnimatedSticker__container-ca0080 {
  position: relative;
}

.AnimatedSticker__sticker-preview-e2a504 {
  position: absolute;
  top: 0;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Sticker/AnimatedSticker/AnimatedSticker.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AACF","sourcesContent":[".sticker {\n  display: inline-block;\n}\n\n.container {\n  position: relative;\n}\n\n.sticker-preview {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sticker": `AnimatedSticker__sticker-dcfaf5`,
	"container": `AnimatedSticker__container-ca0080`,
	"sticker-preview": `AnimatedSticker__sticker-preview-e2a504`,
	"stickerPreview": `AnimatedSticker__sticker-preview-e2a504`
};
module.exports = ___CSS_LOADER_EXPORT___;
